<template>
	<div>
		<el-dialog
			:visible.sync="viewQuestionImagesDialog"
			:before-close="handleClose"
			:fullscreen="false"
			width="750px"
			title="Media"
			class="header"
		>
			<el-row>
				<el-col :span="4" v-for="(item, idx) in imagesArray" :key="idx">
					<div style="cursor: pointer">
						<el-tooltip
							class="item"
							effect="light"
							content="Click to show image"
							placement="bottom"
						>
							<img 
								v-if="
									item.file_name.includes('image') ||
									item.file_name.includes('jpg') ||
									item.file_name.includes('jpeg') ||
									item.file_name.includes('png') ||
									item.file_name.includes('gif') ||
									item.file_name.includes('bmp') ||
									item.file_name.includes('webp')
								"
								width="100%"
								height="100%"
								:src="item.src"
								@click="show_excel(item.src)"
							/>
						</el-tooltip>
						<el-tooltip
							class="item"
							v-if="
								item.file_name.includes('mp4') ||
								item.file_name.includes('mov') ||
								item.file_name.includes('wmv') ||
								item.file_name.includes('avi') ||
								item.file_name.includes('avchd') ||
								item.file_name.includes('flv') ||
								item.file_name.includes('f4v') ||
								item.file_name.includes('swf') ||
								item.file_name.includes('mkv') ||
								item.file_name.includes('webm') ||
								item.file_name.includes('mpg') ||
								item.file_name.includes('mp2') ||
								item.file_name.includes('mpeg') ||
								item.file_name.includes('mpe') ||
								item.file_name.includes('mpv') ||
								item.file_name.includes('video')
							"
							effect="light"
							content="Click to show video"
							placement="bottom"
						>
							<video
								:src="item.src"
								@click="show_excel(item.src)"
								style="height: 50px"
							/>
						</el-tooltip>
						<el-tooltip
							v-if="item.file_name.includes('pdf')"
							class="item"
							effect="light"
							content="Click to show pdf"
							placement="bottom"
						>
							<img
								style="height: 50px"
								@click="show_excel(item.src)"
								src="../../../assets/icons/pdf.png"
							/>
						</el-tooltip>
						<el-tooltip
							v-if="
								item.file_name.includes('csv') ||
								item.file_name.includes('sheet')
							"
							class="item"
							effect="light"
							content="Click to show excel"
							placement="bottom"
						>
							<img
								style="height: 50px"
								@click="show_excel(item.src)"
								src="../../../assets/icons/excel.png"
							/>
						</el-tooltip>
						<!-- <div class="text-right">
							<i @click="delete_image(item)" class="el-icon-delete" />
						</div> -->
					</div>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		viewQuestionImagesDialog: Boolean,
		imagesArray: Array,
	},
	data: () => ({}),
	methods: {
		handleClose() {
			this.$emit("close");
		},
		show_excel(excel) {
			window.open(excel);
		},
	},
};
</script>

<style></style>
